import { render, staticRenderFns } from "./company-share.vue?vue&type=template&id=e139793c&scoped=true&"
import script from "./company-share.vue?vue&type=script&lang=js&"
export * from "./company-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e139793c",
  null
  
)

export default component.exports